import React from 'react';
import toastr from 'toastr';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Claim from '../../../Logic/Claim';
import ClaimStatus from '../../common/ClaimStatus/ClaimStatus';

import './SendMessage.css';

class SendMessageClass extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      messageSent: false,
      hasError: false,
      message: '',
    };

    this.setStateValue = this.setStateValue.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
  }

  setStateValue(prop, value) {
    const newState = { ...this.state };
    newState[prop] = value;

    this.setState(newState);
  }

  handleSend = () => {
    this.sendMessage();
    if (this.state.message.length >= 1) {
      this.props.navigate('/complaints');
    }
  };

  handleCancel = () => {
    this.props.navigate('/complaints');
  };

  sendMessage() {
    if (this.state.message.length < 1) {
      toastr.warning('Please compose a message to send.', 'Oops');
    } else {
      Claim.SendComplaintsMessage(this.state.message)
        .then(() => {
          toastr.success("Your message is on it's way.", 'Success');
        })
        .catch(() => {
          toastr.error(
            'Something went wrong and we are unable to deliver your message.',
            'Oops',
          );
        });
    }
  }

  hideAlert() {
    this.setStateValue('alert', null);
  }

  render() {
    return (
      <div className="row">
        <ClaimStatus />
        <div className="col-xs-12"><h4>Send a message</h4></div>
        <div className="col-xs-12 form-group">
          <textarea
            style={{ height: '25vh', fontSize: '16px' }}
            value={this.state.message}
            onChange={(event) => {
              this.setStateValue('message', event.target.value);
            }}
            className="form-control"
          />
          <div className="row mt-3 flex-row">
            <div className="col-6">
              <button
                type="button"
                onClick={this.handleSend}
                className="btn btn-success btn-lg w-100"
              >
                Send
              </button>
            </div>
            <div className="col-6">
              <button
                type="button"
                onClick={this.handleCancel}
                className="btn btn-warning btn-lg w100"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SendMessageClass.propTypes = {
  navigate: PropTypes.func.isRequired,
};

function SendMessage(props) {
  const navigate = useNavigate();
  return <SendMessageClass {...props} navigate={navigate} />;
}

export default SendMessage;
